// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { loadTranslations as loadTranslationsAdOperatorAvailability } from '@backoffice-frontend/ad-operator-availability/locales'
import { loadTranslations as loadTranslationsAdOperatorCall } from '@backoffice-frontend/ad-operator-call/locales'
import { loadTranslations as loadTranslationsAdOperatorDrawer } from '@backoffice-frontend/ad-operator-drawer/locales'
import { loadTranslations as loadTranslationsAdOperatorReportIo } from '@backoffice-frontend/ad-operator-report-io/locales'
import { loadTranslations as loadTranslationsAdOperatorVideo } from '@backoffice-frontend/ad-operator-video/locales'
import { loadTranslations as loadTranslationsAdPassengerList } from '@backoffice-frontend/ad-passenger-list/locales'
import { loadTranslations as loadTranslationsAdPoolingToggle } from '@backoffice-frontend/ad-pooling-toggle/locales'
import { loadTranslations as loadTranslationsAdRemoteOperationsCommon } from '@backoffice-frontend/ad-remote-operations-common/locales'
import { loadTranslations as loadTranslationsAdTelematicsCards } from '@backoffice-frontend/ad-telematics-cards/locales'
import { loadTranslations as loadTranslationsAdVehicleStream } from '@backoffice-frontend/ad-vehicle-stream/locales'
import { loadTranslations as loadTranslationsAlertCards } from '@backoffice-frontend/alert-cards/locales'
import { loadTranslations as loadTranslationsAlertCardsCommon } from '@backoffice-frontend/alert-cards-common/locales'
import { loadTranslations as loadTranslationsAlertDrawer } from '@backoffice-frontend/alert-drawer/locales'
import { loadTranslations as loadTranslationsAlertsCommon } from '@backoffice-frontend/alerts-common/locales'
import { loadTranslations as loadTranslationsAreaComponents } from '@backoffice-frontend/area-components/locales'
import { loadTranslations as loadTranslationsAuthenticatedAppView } from '@backoffice-frontend/authenticated-app-view/locales'
import { loadTranslations as loadTranslationsCommandPalette } from '@backoffice-frontend/command-palette/locales'
import { loadTranslations as loadTranslationsCubeDashboard } from '@backoffice-frontend/cube-dashboard/locales'
import { loadTranslations as loadTranslationsCustomerComponents } from '@backoffice-frontend/customer-components/locales'
import { loadTranslations as loadTranslationsDisruptionAgent } from '@backoffice-frontend/disruption-agent/locales'
import { loadTranslations as loadTranslationsEmployeeAutocompleteField } from '@backoffice-frontend/employee-autocomplete-field/locales'
import { loadTranslations as loadTranslationsEmployeeIdentity } from '@backoffice-frontend/employee-identity/locales'
import { loadTranslations as loadTranslationsFeeInvoicing } from '@backoffice-frontend/fee-invoicing/locales'
import { loadTranslations as loadTranslationsFleetMapsCommon } from '@backoffice-frontend/fleet-maps-common/locales'
import { loadTranslations as loadTranslationsFleetTracing } from '@backoffice-frontend/fleet-tracing/locales'
import { loadTranslations as loadTranslationsLeafletMapCommon } from '@backoffice-frontend/leaflet-map-common/locales'
import { loadTranslations as loadTranslationsLoginView } from '@backoffice-frontend/login-view/locales'
import { loadTranslations as loadTranslationsOverwatchMapCommon } from '@backoffice-frontend/overwatch-map-common/locales'
import { loadTranslations as loadTranslationsPatterns } from '@backoffice-frontend/patterns/locales'
import { loadTranslations as loadTranslationsPayment } from '@backoffice-frontend/payment/locales'
import { loadTranslations as loadTranslationsReportIoLib } from '@backoffice-frontend/report-io-lib/locales'
import { loadTranslations as loadTranslationsSamCommon } from '@backoffice-frontend/sam-common/locales'
import { loadTranslations as loadTranslationsServiceAreaPicker } from '@backoffice-frontend/service-area-picker/locales'
import { loadTranslations as loadTranslationsServiceCancellation } from '@backoffice-frontend/service-cancellation/locales'
import { loadTranslations as loadTranslationsServiceMetrics } from '@backoffice-frontend/service-metrics/locales'
import { loadTranslations as loadTranslationsShiftsEmployee } from '@backoffice-frontend/shifts-employee/locales'
import { loadTranslations as loadTranslationsTables } from '@backoffice-frontend/tables/locales'
import { loadTranslations as loadTranslationsTemporaryBackofficeSessionsCommon } from '@backoffice-frontend/temporary-backoffice-sessions-common/locales'
import { loadTranslations as loadTranslationsTracingReplay } from '@backoffice-frontend/tracing-replay/locales'
import { loadTranslations as loadTranslationsTracingTime } from '@backoffice-frontend/tracing-time/locales'
import { loadTranslations as loadTranslationsTranslations } from '@backoffice-frontend/translations/locales'
import { loadTranslations as loadTranslationsTripComponents } from '@backoffice-frontend/trip-components/locales'
import { loadTranslations as loadTranslationsTripTracing } from '@backoffice-frontend/trip-tracing/locales'
import { loadTranslations as loadTranslationsUserManagementUi } from '@backoffice-frontend/user-management-ui/locales'
import { loadTranslations as loadTranslationsValidators } from '@backoffice-frontend/validators/locales'
import { loadTranslations as loadTranslationsVehicleChecks } from '@backoffice-frontend/vehicle-checks/locales'
import { loadTranslations as loadTranslationsVehicleCommon } from '@backoffice-frontend/vehicle-common/locales'
import { loadTranslations as loadTranslationsVehicleMission } from '@backoffice-frontend/vehicle-mission/locales'
import { loadTranslations as loadTranslationsWorkOrdersComponents } from '@backoffice-frontend/work-orders-components/locales'

export const loadSharedLibTranslations = () => {
  loadTranslationsServiceAreaPicker()
  loadTranslationsAreaComponents()
  loadTranslationsValidators()
  loadTranslationsTranslations()
  loadTranslationsLoginView()
  loadTranslationsAuthenticatedAppView()
  loadTranslationsTemporaryBackofficeSessionsCommon()
  loadTranslationsCommandPalette()
  loadTranslationsPatterns()
  loadTranslationsTables()
  loadTranslationsUserManagementUi()
  loadTranslationsOverwatchMapCommon()
  loadTranslationsAdRemoteOperationsCommon()
  loadTranslationsAdOperatorAvailability()
  loadTranslationsAdOperatorCall()
  loadTranslationsAdOperatorVideo()
  loadTranslationsServiceMetrics()
  loadTranslationsAdOperatorDrawer()
  loadTranslationsAdOperatorReportIo()
  loadTranslationsAdPassengerList()
  loadTranslationsAdPoolingToggle()
  loadTranslationsAdTelematicsCards()
  loadTranslationsAdVehicleStream()
  loadTranslationsDisruptionAgent()
  loadTranslationsAlertCards()
  loadTranslationsAlertCardsCommon()
  loadTranslationsAlertDrawer()
  loadTranslationsFleetMapsCommon()
  loadTranslationsVehicleMission()
  loadTranslationsSamCommon()
  loadTranslationsLeafletMapCommon()
  loadTranslationsVehicleCommon()
  loadTranslationsServiceCancellation()
  loadTranslationsEmployeeIdentity()
  loadTranslationsShiftsEmployee()
  loadTranslationsAlertsCommon()
  loadTranslationsCustomerComponents()
  loadTranslationsPayment()
  loadTranslationsWorkOrdersComponents()
  loadTranslationsTripComponents()
  loadTranslationsEmployeeAutocompleteField()
  loadTranslationsReportIoLib()
  loadTranslationsVehicleChecks()
  loadTranslationsFeeInvoicing()
  loadTranslationsTracingTime()
  loadTranslationsTracingReplay()
  loadTranslationsTripTracing()
  loadTranslationsFleetTracing()
  loadTranslationsCubeDashboard()
}
